import { utilities } from 'core';

import type { DrawerNavigationState } from './StackNavigatorProvider.d';
import { ACTION } from './StackNavigatorProvider.d';

const hasOpenedDrawer = (drawerStack: DrawerNavigationState['drawerStack']) =>
  drawerStack.some(({ open }) => open);

export const drawerInitialState: DrawerNavigationState = {
  drawerStack: [],
  hasOpenDrawers: false,
};

export const drawerReducer = utilities.createReducer<DrawerNavigationState>(
  {
    [ACTION.CLOSE_ALL_DRAWERS]: (draft) => {
      const closedDrawers = draft.drawerStack.map((drawer) => ({
        ...drawer,
        open: false,
      }));

      draft.drawerStack = closedDrawers;
      draft.hasOpenDrawers = false;
    },

    [ACTION.POP_STATE_FROM_DRAWER_STACK]: (draft, { payload }) => {
      const drawerStack = draft.drawerStack.filter(({ id }) => id !== payload);

      draft.drawerStack = drawerStack;
    },

    [ACTION.PUSH_STATE_TO_DRAWER_STACK]: (draft, { payload }) => {
      const drawerExists = draft.drawerStack.find(({ id }) => id === payload.id);

      if (!drawerExists) {
        draft.drawerStack.push(payload);
        draft.hasOpenDrawers = hasOpenedDrawer(draft.drawerStack);
      }
    },

    [ACTION.UPDATE_DRAWER_STACK]: (draft, { payload }) => {
      const updateIndex = draft.drawerStack.findIndex(({ id }) => id === payload.id);
      const currentDrawer = draft.drawerStack[updateIndex];

      draft.drawerStack[updateIndex] = {
        ...currentDrawer,
        children: payload.children,
        footer: payload.footer,
        header: payload.header,
        headerIcon: payload.headerIcon,
        open: payload.open,
        title: payload.title,
      };

      draft.hasOpenDrawers = hasOpenedDrawer(draft.drawerStack);
    },
  },
  drawerInitialState,
);
